<template>
    <div class="comp__table-product-info">
        <div class="comp__table-product-image">
            <ImageField
                class="comp__table-product-image"
                :key="product.Color"
                :obj="{ 'url': getProductImage(product, product?.Color), 'alt': 'Feature Image', 'width': 225, 'height': 297 }"
            />
        </div>
        <div class="comp__table-product-right">
            <div class="comp__table-product-inner-info">
                <span class="comp__table-product-title">{{ product.title }}</span>
                <ProductPrice
                    :key="product.Color"
                    :product="product"
                    :selectedFirstOption="firstLevelSelectedOption"
                />
            </div>
            <div class="comp__table-product-ctas">
                <button @click="redirectToBottom" class="comp__table-product-atc" tabindex="0">Add to Cart</button>
                <button @click="() => onProductRemove(product)" class="comp__table-product-remove">Remove</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, toRefs } from 'vue';
import { useStore } from 'vuex';
import ImageField from '../image.vue';
import ProductPrice from '../../pdp-first-fold/components/product-price.vue';

const props = defineProps({
    product: Object,
    getProductImage: Function,
    redirectToBottom: Function,
    onProductRemove: Function
});

const { product } = toRefs(props);
const store = useStore();

const firstLevelSelectedOption = computed(() => {
    return store.state.pdp.firstLevelOptions?.[product.value.id] || {};
});

</script>
